import { render, staticRenderFns } from "./TankTab.vue?vue&type=template&id=28a9f1a1&scoped=true&"
import script from "./TankTab.vue?vue&type=script&lang=js&"
export * from "./TankTab.vue?vue&type=script&lang=js&"
import style0 from "./TankTab.vue?vue&type=style&index=0&id=28a9f1a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a9f1a1",
  null
  
)

export default component.exports